import { ReactNode } from "react";
import { Routes, Route, Navigate } from "react-router";

/** The `ShellSwitch` component properties. */
export interface ShellSwitchProps {

  /** The component children. */
  readonly children?: ReactNode;
}

/** Component which replaces the `Switch` component in React Router to supply a default 404 route. */
export const ShellSwitch = (props: ShellSwitchProps): ReactNode => {
  const { children, ...rest } = props;

  return (
    <Routes {...rest}>
      {children}
      <Route element={<Navigate to="/404" />} />
    </Routes>
  );
};
